import React, { useState, useContext } from "react";
import { Link, useNavigate } from "react-router-dom";

import SearchContext from "contexts/SearchContext";

import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";

function NavSearch() {
  // "setContextSearchValue" variable used to provide/update Search context
  const [contextSearchValue, setContextSearchValue] = useContext(SearchContext);

  // Define initial state
  const [searchInputValue, setSearchInputValue] = useState("");
  const [searchError, setSearchError] = useState(false);
  const navigate = useNavigate();

  const handleChange = function(event) {
    setSearchInputValue(event.target.value);
    if (event.target.validity.valid) {
      setSearchError(false);
    } else {
      setSearchError(true);
    }
  };

  const handleSubmit = function(event) {
    event.preventDefault();

    if (searchInputValue === "") {
      setSearchError(true);
    } else {
      setSearchError(false);
      setContextSearchValue(searchInputValue); // provide/update Search context
      navigate("/search"); // Redirect to Search Results page
    }
  };

  // Reset Search context to empty when getting all recipes on Home page
  const clearSearch = function(event) {
    setSearchInputValue("");
    setContextSearchValue("");
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <AppBar position="static" color="transparent" sx={{ mb: 3, alignItems: "center" }}>
          <Toolbar>
            <Stack direction="row" spacing={2} sx={{ mr: 1 }}>
              <Link to="/recipes" onClick={clearSearch} style={{ color: "grey", textDecoration: "none" }}>
                Home
              </Link>
              <Link to="/favorites" style={{ color: "grey", textDecoration: "none" }}>
                Favorites
              </Link>
            </Stack>
            <Stack direction="row" my={2}>
              <TextField 
                type="search" 
                value={searchInputValue} 
                id="recipes-search" 
                label="Search Recipes" 
                variant="outlined" 
                size="small" 
                onChange={handleChange} 
                error={searchError} 
                helperText={searchError ? "Please enter a search term" : ""}
              />
              <IconButton onClick={handleSubmit}>
                <SearchIcon />
              </IconButton>
            </Stack>
          </Toolbar>
        </AppBar>
      </form>
    </>
  );
}

export default NavSearch;